import React from "react";
import PropTypes from "prop-types";
import { FaUserAlt, FaRegBookmark, FaCalendar } from "react-icons/fa";

import { Container, Sessao, Info, Content, Categorias } from "./styles";

import { formataDataUtcToDDMMYYYY } from "../../../../utils/functions/format";

function Conteudo(props) {
  const dataFormatada = formataDataUtcToDDMMYYYY(
    props.noticia.data_de_publicacao
  );
  return (
    <Sessao>
      <Container>
        <p>{props.noticia.titulo}</p>
        <Info>
          <p>
            <FaUserAlt size={13} /> {props.noticia.autor}
          </p>
          <p>
            <FaCalendar size={13} /> {dataFormatada}
          </p>
          <p>
            <FaRegBookmark size={13} />
            <Categorias>
              {props.noticia.categorias.map((categoria) => {
                return `${categoria.titulo} ${
                  props.noticia.categorias.length > 1 ? "|" : ""
                } `;
              })}
            </Categorias>
          </p>
        </Info>
        <Content
          dangerouslySetInnerHTML={{ __html: props.noticia.content_texto }}
        />
      </Container>
    </Sessao>
  );
}

Conteudo.propTypes = {
  noticia: PropTypes.object,
};

export default Conteudo;
